module.exports = __webpack_public_path__ + "img/img_34.0ef0b487.png";